import { render, staticRenderFns } from "./CP.vue?vue&type=template&id=73f4b1a7&scoped=true"
import script from "./CP.vue?vue&type=script&lang=js"
export * from "./CP.vue?vue&type=script&lang=js"
import style0 from "./CP.vue?vue&type=style&index=0&id=73f4b1a7&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f4b1a7",
  null
  
)

export default component.exports